import React from 'react';
import IIcon from '../../types/IIcon';

const Instagram = ({
  color = 'var(--color-white)',
  width = 20,
  height = 20,
}: IIcon) => {
  return (
    <>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        fill='none'
        width={width}
        height={height}
        viewBox='0 0 20 20'
      >
        <path
          fill={color}
          d='M10 0c3.9946 0 5.9921.0003 7.4307.9521a5.7333 5.7333 0 0 1 1.6172 1.6172C19.9997 4.008 20 6.0054 20 10c0 3.9945-.0003 5.9921-.9521 7.4307a5.7338 5.7338 0 0 1-1.6172 1.6172C15.9921 19.9997 13.9946 20 10 20c-3.9946 0-5.992-.0003-7.4307-.9521a5.7335 5.7335 0 0 1-1.6172-1.6172C.0003 15.9921 0 13.9945 0 10c0-3.9946.0003-5.992.9521-7.4307A5.7327 5.7327 0 0 1 2.5693.9521C4.008.0003 6.0054 0 10 0Zm0 4.8232C7.1409 4.8232 4.8224 7.141 4.8223 10c0 2.8592 2.3185 5.1777 5.1777 5.1777 2.8591-.0001 5.1768-2.3186 5.1768-5.1777C15.1766 7.141 12.859 4.8234 10 4.8232Zm0 1.752c1.8916.0002 3.4246 1.5332 3.4248 3.4248 0 1.8918-1.5331 3.4256-3.4248 3.4258-1.8919 0-3.4258-1.5339-3.4258-3.4258C6.5744 8.1083 8.1082 6.5752 10 6.5752Zm5.3818-3.2285c-.6718 0-1.2168.545-1.2168 1.2168.0002.6716.5451 1.2158 1.2168 1.2158.6718 0 1.2167-.5441 1.2168-1.2158 0-.6719-.5449-1.2168-1.2168-1.2168Z'
        />
      </svg>
    </>
  );
};

export default Instagram;
